import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Tooltip from 'flarum/common/components/Tooltip';
import Avatar from 'flarum/common/components/Avatar';
import Icon from 'flarum/common/components/Icon';
import humanTime from 'flarum/common/utils/humanTime';
import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';
export default class DiscussionOverview extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "discussion", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
  }
  view() {
    return m("div", {
      className: "DiscussionOverview"
    }, m("div", {
      className: "DiscussionOverview-stats"
    }, this.statItems().toArray()), this.participantSection());
  }
  statItems() {
    const items = new ItemList();
    const discussion = this.discussion;
    items.add('created', m("div", {
      className: "DiscussionOverview-stat"
    }, m(Icon, {
      name: "far fa-clock"
    }), m("div", {
      className: "DiscussionOverview-stat-content"
    }, m("span", {
      className: "DiscussionOverview-stat-label"
    }, app.translator.trans('datlechin-discussion-overview.forum.created')), m("span", {
      className: "DiscussionOverview-stat-value"
    }, discussion.createdAt() ? humanTime(discussion.createdAt()) : '—'))), 100);
    const lastPostedAt = discussion.lastPostedAt();
    const lastPostedUser = discussion.lastPostedUser();
    items.add('lastReply', m("div", {
      className: "DiscussionOverview-stat"
    }, m(Icon, {
      name: "fas fa-reply"
    }), m("div", {
      className: "DiscussionOverview-stat-content"
    }, m("span", {
      className: "DiscussionOverview-stat-label"
    }, app.translator.trans('datlechin-discussion-overview.forum.last_reply')), m("span", {
      className: "DiscussionOverview-stat-value"
    }, lastPostedUser ? m(Avatar, {
      user: lastPostedUser
    }) : null, lastPostedAt ? humanTime(lastPostedAt) : '—'))), 90);
    items.add('replies', m("div", {
      className: "DiscussionOverview-stat"
    }, m(Icon, {
      name: "far fa-comment"
    }), m("div", {
      className: "DiscussionOverview-stat-content"
    }, m("span", {
      className: "DiscussionOverview-stat-value DiscussionOverview-stat-value--number"
    }, discussion.replyCount()), m("span", {
      className: "DiscussionOverview-stat-label"
    }, app.translator.trans('datlechin-discussion-overview.forum.replies')))), 80);
    if (app.initializers.has('michaelbelgium-discussion-views')) {
      var _viewCount, _ref;
      items.add('views', m("div", {
        className: "DiscussionOverview-stat"
      }, m(Icon, {
        name: "far fa-eye"
      }), m("div", {
        className: "DiscussionOverview-stat-content"
      }, m("span", {
        className: "DiscussionOverview-stat-value DiscussionOverview-stat-value--number"
      }, ((_viewCount = (_ref = discussion).viewCount) == null ? void 0 : _viewCount.call(_ref)) || 0), m("span", {
        className: "DiscussionOverview-stat-label"
      }, app.translator.trans('datlechin-discussion-overview.forum.views')))), 70);
    }
    const posts = (discussion.posts() || []).filter(Boolean);
    const firstPost = posts[0];
    const likesCount = (firstPost == null ? void 0 : firstPost.attribute('likesCount')) || 0;
    items.add('likes', m("div", {
      className: "DiscussionOverview-stat"
    }, m(Icon, {
      name: "far fa-thumbs-up"
    }), m("div", {
      className: "DiscussionOverview-stat-content"
    }, m("span", {
      className: "DiscussionOverview-stat-value DiscussionOverview-stat-value--number"
    }, likesCount), m("span", {
      className: "DiscussionOverview-stat-label"
    }, app.translator.trans('datlechin-discussion-overview.forum.likes')))), 60);
    return items;
  }
  participantSection() {
    const discussion = this.discussion;
    const posts = (discussion.posts() || []).filter(Boolean);
    const participantCount = discussion.attribute('participantCount') || 0;
    const participantUsers = new Set();
    posts.forEach(post => {
      var _post$user;
      const user = (_post$user = post.user) == null ? void 0 : _post$user.call(post);
      if (user) participantUsers.add(user);
    });
    if (participantUsers.size === 0) return null;
    return m("div", {
      className: "DiscussionOverview-participants"
    }, m("div", {
      className: "DiscussionOverview-participants-avatars"
    }, Array.from(participantUsers).map(user => m(Tooltip, {
      key: user.id(),
      text: user.displayName()
    }, m(Link, {
      href: app.route.user(user),
      className: "DiscussionOverview-participants-avatar"
    }, m(Avatar, {
      user: user
    }))))), participantCount > 0 ? m("span", {
      className: "DiscussionOverview-participants-count"
    }, app.translator.trans('datlechin-discussion-overview.forum.users'), ' · ', participantCount) : null);
  }
}
flarum.reg.add('datlechin-discussion-overview', 'forum/components/DiscussionOverview', DiscussionOverview);